@use "../../styles/breakpoint.module.scss" as *;

.dotsWrapper {
    display: none;
    grid-column: content;
    justify-content: center;

    @media ($below-tablet) {
        display: flex;
    }

    --dot-width: 8px;
    --dot-color: var(--transparent-20);
    --dot-active-color: var(--black);
}

.dot {
    composes: base from "./index.module.scss";
    composes: dot from "../Carousel/Dots.module.scss";
}
